import { search } from './../../admin/tribe-graphql';
import { MatSort } from '@angular/material/sort';
import { RegConfigService } from 'src/app/pages/admin/reg-config-service';
import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MenuService } from '../menu.service';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MenuDialogComponent } from '../Forms/menu-dialog/menu-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-menus',
  templateUrl: './manage-menus.component.html',
  styleUrls: ['./manage-menus.component.scss'],
})
export class ManageMenusComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  pageTitle = ' Menu List';
  displayedColumns: string[] = [
    'no',
    'title',
    'sorting',
    'icon',
    'routerLink',
    'isParent',
    'target',
    'actions',
  ];

  menuList: MatTableDataSource<any>;
  searchKey: string;
  loading = false;
  deleted: string;
  cancel: string;

  formData: any = {};
  parentMenus: any = [];
  dialogRef: MatDialogRef<MenuDialogComponent>;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private menus: MenuService,
    private dialog: MatDialog,
    private configService: RegConfigService
  ) { }

  prepareMenuList(response) {

    const data =
      response && response.data
        ? response.data.map((item) => ({
          ...item,
          isParent: item.hasSubMenu ? 'Yes' : 'No',
          isSubMenu: item.parentId === null ? false : true,
        }))
        : [];
    this.menuList = new MatTableDataSource(data);
    this.menuList.sort = this.sort;
    this.menuList.paginator = this.paginator;
  }

  getMenus() {
    this.subs.push(
      this.menus.get().subscribe((response) => {
        this.prepareMenuList(response);
      })
    );
  }
  fetchParentMenus() {
    this.menus.getParentMenus().subscribe((response) => {
      this.parentMenus = response.data;
    });
  }
  filterTable(data) {
    if (data.target.value.length > 0) {
      this.menus.searchByName(data.target.value).subscribe((response) => {
        this.prepareMenuList(response);
      });
    } else {
      this.getMenus();
    }
  }
  save(payload) {
    if (payload.id) {
      this.updateMenu(payload);
    } else {
      this.saveMenu(payload);
    }
  }
  updateMenu(payload) {
    this.menus.updateMenus(payload).subscribe((response) => {
      if (response.code === 200) {
        //  Swal.fire(response.description, '', 'success');
        this.getMenus();
      } else {
        Swal.fire(response.description, '', 'error');
      }
    });
  }
  saveMenu(payload) {
    this.menus.saveMenus(payload).subscribe((response) => {
      if (response.code === 200) {
        // Swal.fire(response.description, '', 'success');
        this.getMenus();

      } else {
        // Swal.fire(response.description, '', 'error');
      }
    });
  }

  deleteFunction(data) {
    this.formData = data;

    Swal.fire({
      title: 'Are you sure you want to delete this item?',
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
      cancelButtonColor: 'red',
    }).then((result) => {
      if (result.isConfirmed) {
        this.menus.deleteMenus(data.id).subscribe((response) => {
          if (response.code === 200) {
            this.dialogRef.componentInstance.closeDialog()
            this.getMenus();
            // Swal.fire('Deleted successfully', '', 'success');
            setTimeout(() => {
              Swal.close();
            }, 1000);
          } else {
            Swal.fire(response.description, '', 'error');
          }
        });
      } else if (result.isDismissed) {
        //Swal.fire('Item not Deleted', '', 'info');
      }
    });
  }

  openDialog(data): void {
    this.dialogRef = this.dialog.open(MenuDialogComponent, {
      width: '900px',
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'custom-dialog-panel-class',
      disableClose: true,
      data: {
        parentMenus: this.parentMenus,
        ...data,
      },
    });

    this.dialogRef.componentInstance.saveFunction.subscribe(
      (saveData) => {
        this.save(saveData);
        this.closeDialog();
      }
    );
  }
  closeDialog() {
    this.dialog.closeAll();
    this.formData = {};
  }

  ngOnInit(): void {
    this.getMenus();
    this.fetchParentMenus();
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => sub.unsubscribe());
    }
  }
}
